<template>
  <div>
    <Card>
      <div class="md:grid md:grid-cols-3">
        <div class="md:col-span-1 flex flex-col">
          <CardHeader>
            <img v-if="titleImage" class="mb-4 h-16 w-auto m-auto" :src="titleImage" />
            <CardTitle>
              {{ title }}
              <slot name="title-icon"></slot>
            </CardTitle>
            <CardDescription>
              {{ description }}
            </CardDescription>
          </CardHeader>
        </div>
        <CardContent class="md:col-span-2">
          <form class="space-y-6">
            <slot></slot>
          </form>
        </CardContent>
      </div>
      <CardFooter>
        <slot name="footer"></slot>
      </CardFooter>
    </Card>
    <div class="mt-4 flex justify-end">
      <TButton
        v-if="!hidecancel"
        class="mr-2"
        :label="cancel ? cancel : 'Cancel'"
        color="white"
        @click="handleCancel"
      />
      <TButton
        v-if="showSecondaryAction"
        class="mr-2"
        :label="secondaryAction"
        color="white"
        @click="handleSecondaryAction"
      />
      <TButton
        v-if="!hideaction"
        :label="action"
        :color="actioncolor ? actioncolor : 'indigo'"
        :disabled="actionDisabled"
        @click="handleAction"
      >
        <LocalLoadingSpinner />
      </TButton>
    </div>
  </div>
</template>

<script>
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import LocalLoadingSpinner from './LocalLoadingSpinner.vue';

export default {
  components: {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
    LocalLoadingSpinner,
  },
  props: {
    title: String,
    description: String,
    cancel: String,
    action: String,
    hidecancel: Boolean,
    hideaction: Boolean,
    titleImage: String,
    actioncolor: String,
    showSecondaryAction: Boolean,
    secondaryAction: String,
    actionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('handleCancel');
    },
    handleAction() {
      this.$emit('handleAction');
    },
    handleSecondaryAction() {
      this.$emit('handleSecondaryAction');
    },
  },
};
</script>
